import { CommonModule } from '@angular/common';
import { NgbActiveOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { Component, inject } from '@angular/core';
import {
  CustomerSalesPurchaseFromExternalQuoteService,
  CustomerSalesPurchaseService,
} from '@digiwall/goliath-documents/proxy';
import { DialogBoxComponent } from '@digiwall/ui-kit';
import { DwInputRequiredDirective, LoadingService } from '@digiwall/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { LocalizationModule, LocalizationService } from '@abp/ng.core';
import { mergeMap, of } from 'rxjs';
import { Confirmation, ConfirmationService } from '@abp/ng.theme.shared';

@Component({
  selector: 'document-customer-sales-purchase-import',
  templateUrl: './customer-sales-purchase-import.component.html',
  imports: [
    CommonModule,
    DialogBoxComponent,
    DwInputRequiredDirective,
    ReactiveFormsModule,
    FormsModule,
    LocalizationModule,
  ],
})
export class SalesPurchaseImportComponent {
  protected quoteNumber: number;

  activeCanva = inject(NgbActiveOffcanvas);

  constructor(
    private salesPurchaseFromExternalQuoteService: CustomerSalesPurchaseFromExternalQuoteService,
    private salesPurchaseService: CustomerSalesPurchaseService,
    private confirmationService: ConfirmationService,
    private localizationService: LocalizationService,
    private loadingService: LoadingService,
  ) {}

  protected importQuote() {
    this.salesPurchaseService
      .getListByExternalReference(this.quoteNumber.toString())
      .pipe(
        mergeMap(existings => {
          if (existings?.length > 0) {
            return this.confirmationService.warn(
              this.localizationService.instant(
                'Doc::SalesPurchase:QuoteAlreadyImportedWarningMessage',
                this.quoteNumber.toString(),
                existings.map(existing => existing.displayNumber).join('- '),
              ),
              this.localizationService.instant(
                'Doc::SalesPurchase:QuoteAlreadyImportedWarningTitle',
              ),
            );
          }
          return of(Confirmation.Status.confirm);
        }),
      )
      .subscribe(confirmationResult => {
        if (confirmationResult == Confirmation.Status.confirm) {
          this.loadingService.interceptNextRequest();
          this.salesPurchaseFromExternalQuoteService
            .createFromQuote(this.quoteNumber)
            .subscribe(salesPurchase => {
              if (salesPurchase != null) {
                this.activeCanva.close(salesPurchase);
              }
            });
        } else {
          this.activeCanva.close();
        }
      });
  }
}
